export const ScrNotAuthorized = () => {
  return (
    <svg
      width="278"
      height="248"
      viewBox="0 0 278 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M154.473 232.001C215.93 232.001 265.754 182.177 265.754 120.5C265.754 58.824 215.711 9 154.473 9C93.0164 9 43.1924 58.824 43.1924 120.5C43.1924 182.177 93.0164 232.001 154.473 232.001Z"
        fill="#EAEEF9"
      />
      <path
        d="M258.511 47.4122C263.481 47.4122 267.51 43.3832 267.51 38.4131C267.51 33.4431 263.481 29.4141 258.511 29.4141C253.541 29.4141 249.512 33.4431 249.512 38.4131C249.512 43.3832 253.541 47.4122 258.511 47.4122Z"
        fill="#EAEEF9"
      />
      <path
        d="M271.682 12.2914C275.076 12.2914 277.828 9.53987 277.828 6.1457C277.828 2.75152 275.076 0 271.682 0C268.288 0 265.536 2.75152 265.536 6.1457C265.536 9.53987 268.288 12.2914 271.682 12.2914Z"
        fill="#EAEEF9"
      />
      <path
        d="M49.1184 47.1898C52.5125 47.1898 55.264 44.4383 55.264 41.0441C55.264 37.65 52.5125 34.8984 49.1184 34.8984C45.7242 34.8984 42.9727 37.65 42.9727 41.0441C42.9727 44.4383 45.7242 47.1898 49.1184 47.1898Z"
        fill="#EAEEF9"
      />
      <path
        d="M11.5863 165.714C17.8898 165.714 22.9997 160.604 22.9997 154.3C22.9997 147.997 17.8898 142.887 11.5863 142.887C5.28282 142.887 0.172852 147.997 0.172852 154.3C0.172852 160.604 5.28282 165.714 11.5863 165.714Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_13206_324959)">
        <path
          d="M230.197 64.7469L231.953 206.098C231.953 210.927 228.002 214.658 223.173 214.658H85.3343C80.5055 214.658 76.5547 210.707 76.5547 206.098V24.3609C76.5547 19.5321 80.5055 15.8008 85.3343 15.8008H185.202L230.197 64.7469Z"
          fill="url(#paint0_linear_13206_324959)"
        />
      </g>
      <path
        d="M143.72 186.344H116.722C115.625 186.344 114.747 185.247 114.747 183.93C114.747 182.613 115.625 181.516 116.722 181.516H143.72C144.817 181.516 145.695 182.613 145.695 183.93C145.695 185.466 144.817 186.344 143.72 186.344Z"
        fill="#D5DDEA"
      />
      <path
        d="M128.354 186.344H98.9422C97.8448 186.344 96.9668 185.247 96.9668 183.93C96.9668 182.613 97.8448 181.516 98.9422 181.516H128.354C129.451 181.516 130.329 182.613 130.329 183.93C130.329 185.466 129.451 186.344 128.354 186.344Z"
        fill="#D5DDEA"
      />
      <path
        d="M165.886 45.4333H99.8202C98.2837 45.4333 96.9668 44.1163 96.9668 42.5799C96.9668 41.0435 98.2837 39.7266 99.8202 39.7266H165.886C167.423 39.7266 168.74 41.0435 168.74 42.5799C168.74 44.1163 167.423 45.4333 165.886 45.4333Z"
        fill="#D5DDEA"
      />
      <path
        d="M125.281 61.238H99.8202C98.2837 61.238 96.9668 59.921 96.9668 58.3846C96.9668 56.8482 98.2837 55.5312 99.8202 55.5312H125.061C126.598 55.5312 127.915 56.8482 127.915 58.3846C127.915 59.921 126.598 61.238 125.281 61.238Z"
        fill="#D5DDEA"
      />
      <path
        d="M185.202 15.8027V54.8718C185.202 60.359 190.031 64.7488 195.518 64.7488H230.197"
        fill="#D5DDEA"
      />
      <path
        d="M210.579 148.365H134.425H126.032H100.647C99.6232 148.365 98.5996 149.391 98.5996 150.827C98.5996 152.058 99.4185 153.289 100.647 153.289H126.032H134.425H210.579C211.603 153.289 212.626 152.263 212.626 150.827C212.422 149.391 211.603 148.365 210.579 148.365Z"
        fill="#D5DDEA"
      />
      <path
        d="M210.374 130.516H182.124H172.502H100.647C99.6232 130.516 98.5996 131.541 98.5996 132.977C98.5996 134.208 99.4185 135.439 100.647 135.439H172.502H182.124H210.374C211.398 135.439 212.422 134.413 212.422 132.977C212.217 131.541 211.398 130.516 210.374 130.516Z"
        fill="#D5DDEA"
      />
      <path
        d="M210.989 112.461H203.619H196.249H100.647C99.6232 112.461 98.5996 113.487 98.5996 114.923C98.5996 116.154 99.4185 117.385 100.647 117.385H196.249H204.438H210.784C211.807 117.385 212.831 116.359 212.831 114.923C213.036 113.692 212.012 112.461 210.989 112.461Z"
        fill="#D5DDEA"
      />
      <path
        d="M130.74 188.164H100.647C99.6232 188.164 98.5996 187.138 98.5996 185.702C98.5996 184.471 99.4185 183.24 100.647 183.24H130.74C131.764 183.24 132.787 184.266 132.787 185.702C132.787 187.343 131.764 188.164 130.74 188.164Z"
        fill="#E3EAF2"
      />
      <path
        d="M211.807 94.6152H187.856H181.919H100.647C99.6232 94.6152 98.5996 95.641 98.5996 97.077C98.5996 98.3079 99.4185 99.5388 100.647 99.5388H181.919H187.856H211.603C213.036 99.5388 213.855 98.5131 213.855 97.077C213.855 95.8461 213.036 94.6152 211.807 94.6152Z"
        fill="#D5DDEA"
      />
      <path
        d="M102.283 199.037H53.9703C48.6477 199.037 44.3486 194.729 44.3486 189.395V122.311C44.3486 103.642 59.4976 88.666 77.922 88.666C96.3465 88.666 111.495 103.847 111.495 122.311V189.6C111.7 194.729 107.401 199.037 102.283 199.037ZM63.5919 179.958H92.6616V122.311C92.6616 114.31 86.1107 107.745 78.1267 107.745C70.1428 107.745 63.5919 114.31 63.5919 122.311V179.958Z"
        fill="#989FB0"
      />
      <path
        d="M122.142 217.292H34.7279C28.7911 217.292 23.8779 212.368 23.8779 206.419V148.361C23.8779 142.412 28.7911 137.488 34.7279 137.488H122.142C128.078 137.488 132.991 142.412 132.991 148.361V206.419C132.991 212.368 128.078 217.292 122.142 217.292Z"
        fill="#C2C8D6"
      />
      <path
        d="M89.3866 168.467C89.3866 172.775 86.9301 176.468 83.4499 178.314V190.213C83.4499 193.085 81.198 195.342 78.332 195.342C75.466 195.342 73.2141 193.085 73.2141 190.213V178.314C69.7339 176.468 67.2773 172.775 67.2773 168.467C67.2773 162.312 72.1905 157.389 78.332 157.389C84.4735 157.389 89.3866 162.312 89.3866 168.467Z"
        fill="#989FB0"
      />
      <defs>
        <filter
          id="filter0_d_13206_324959"
          x="54.5547"
          y="4.80078"
          width="199.398"
          height="242.857"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13206_324959"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_13206_324959"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_13206_324959"
          x1="154.203"
          y1="11.201"
          x2="154.203"
          y2="216.802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
